import React from 'react';
import { View, Text, Image } from '@react-pdf/renderer';
import styles from "../../../Transcript/SchedulePDFStyles"
import { formattedStartAndEndDate, formattedDate } from '../../../Transcript/SchedulePDFUtils';

const SchedulePDFFooter = ({ minDate, maxDate }) => (
   <View>
    <View style={[styles.lastpagebar, styles.lastpagebar1,{ marginBottom: 6 }]}>
      <Text style={{ fontWeight: 'bold' }}> IMPORTANT INFORMATION </Text>
    
     
    </View>
    <View style={[styles.lastpagecontent]}>
      <Text style={{ fontWeight: 'bold' }}>Schedule is Subject to Change <br/></Text>
    
     
    </View>
     <View style={[styles.lastpagecontent,{ marginBottom: 6 }]}>
      <Text>Please login to the Caregiver Learning Center to access the most current schedule.<br/> </Text>
    
     
    </View>
     <View style={[styles.lastpagecontent,{ marginBottom: 6 }]}>
      <Text>Ensure your contact information is current in the Caregiver Learning Center. You will be notified if there are any 
changes to your schedule at the email address (and/or phone number) listed. To make any changes, please contact 
your Employer or the Member Resource Center (MRC) at<Text style={{ color: 'blue' }}> MRC@myseiubenefits.org</Text>. <br/></Text>
    
     
    </View>
       <View style={[styles.lastpagecontent]}>
      <Text style={{ fontWeight: 'bold' }}>Be Prepared for Class </Text>
    
     
    </View>
       <View style={[styles.lastpagecontent,{ marginBottom: 6 }]}>
      <Text>Bring a photo ID, a pen, and a snack. Check your schedule in the Caregiver Learning Center to ensure you have the 
most up-to-date information. Make sure that you arrive on time. Instructors will not allow entry 10 minutes past 
the start time. <br/></Text>
    
     
    </View>
     <View style={[styles.lastpagecontent]}>
      <Text style={{ fontWeight: 'bold' }}>Sign In and Out of the Roster </Text>
    
     
    </View>
     <View style={[styles.lastpagecontent,{ marginBottom: 6 }]}>
      <Text>Remember to sign in and out of the roster at the beginning and end of class. Signatures are required to receive 
class credit. <br/></Text>
    
     
    </View>
    <View style={[styles.lastpagecontent]}>
      <Text style={{ fontWeight: 'bold' }}>Only Registered Students and Approved Interpreters are Allowed in Class </Text>
    
     
    </View>
    <View style={[styles.lastpagecontent,{ marginBottom: 6 }]}>
      <Text>You must be a registered student or an approved interpreter to be admitted. Students may not bring clients, 
children, or any other visitors to class unless previously arranged.<br/> </Text>
    
     
    </View>
     <View style={[styles.lastpagecontent]}>
      <Text style={{ fontWeight: 'bold' }}>Class Cancellations </Text>
    
     
    </View>
     <View style={[styles.lastpagecontent]}>
      <Text>If you need to cancel class registration, you can easily switch your registration to a different location and/or date in the Caregiver Learning Center. </Text>
    
     
    </View>
    </View>
    
);

export default SchedulePDFFooter;
